import React from 'react'

import moment from 'moment'

export const DateTimeFormatter = ({date,fmt}) => {
  return (date) ? (
    <span>{moment(date).format(fmt || 'DD.MM.YY HH:mm')}</span>
  ) : null
}
